/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'

export default function useWindowDimensions() {
  const hasWindow = typeof window !== 'undefined'
  const [width, setWidth] = useState(null)
  const [height, setHeight] = useState(null)

  function handleResize() {
    if (hasWindow) {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }
  }

  useEffect(() => handleResize(), [hasWindow])

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [hasWindow])

  return { width, height }
}
